// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__-lNdL","insightsList":"newBusinessInsightsMenu_insightsList__3xXPe","active":"newBusinessInsightsMenu_active__CuakP"};